import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class SidenavService {
  private mobileMenuToggleSubject = new BehaviorSubject<boolean>(false)
  mobileMenuToggle$ = this.mobileMenuToggleSubject.asObservable()

  toggleMobileMenu() {
    const currentValue = this.mobileMenuToggleSubject.value
    this.mobileMenuToggleSubject.next(!currentValue)
  }

  closeMobileMenu() {
    this.mobileMenuToggleSubject.next(false)
  }

  getMobileMenuState(): boolean {
    return this.mobileMenuToggleSubject.value
  }
}
